var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72544 16.2536C9.44588 16.5331 9.06675 16.6901 8.67144 16.6901C8.27614 16.6901 7.89702 16.5331 7.61745 16.2536L0.90884 9.545C0.629358 9.26543 0.472353 8.88631 0.472353 8.491C0.472353 8.09569 0.629358 7.71657 0.90884 7.437L7.61745 0.728394C7.89862 0.456833 8.2752 0.306568 8.66608 0.309965C9.05696 0.313362 9.43087 0.470146 9.70728 0.746553C9.98369 1.02296 10.1405 1.39687 10.1439 1.78776C10.1473 2.17864 9.997 2.55522 9.72544 2.83639L5.68984 7.0002H19.8525C20.2478 7.0002 20.627 7.15726 20.9066 7.43684C21.1862 7.71642 21.3433 8.09562 21.3433 8.491C21.3433 8.88639 21.1862 9.26558 20.9066 9.54516C20.627 9.82474 20.2478 9.9818 19.8525 9.9818H5.68984L9.72544 14.1456C10.0049 14.4252 10.1619 14.8043 10.1619 15.1996C10.1619 15.5949 10.0049 15.974 9.72544 16.2536Z",
    fill: "#2C358A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrow);
export default __webpack_public_path__ + "static/media/barrow.6c3b0eb289d5022f012d340052c8b992.svg";
export { ForwardRef as ReactComponent };